import { OrbitalDataCloud } from "@/components/ui/orbital-data-cloud"

export default function Hermes() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white p-4">
      <OrbitalDataCloud />
    </div>
  )
}
